import React, { useState, useEffect } from 'react'
import { useHistory, Link } from 'react-router-dom'
import styles from './MenuItems.module.scss'

import pages, { generateUrl } from '../../pages'

interface MenuItem {
  name: string
  id: string | number
  icon: string
  url: string
}

const MENU_ITEMS: MenuItem[] = [
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925672_Home.svg',
    url: '/',
    name: 'Home',
    id: 1,
  },
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925674_Shorts.svg',
    url: '-1',
    name: 'Shorts',
    id: 2,
  },
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925663_Subscriptions.svg',
    url: '/?s=recommended&t=weekly',
    name: 'Subscriptions',
    id: 3,
  },
  {
    icon: 'https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1687162925673_Messages.svg',
    url: '-2',
    name: 'Messages',
    id: 4,
  },
]

const MenuItems = (props: any) => {
  const history = useHistory()

  const [currentUrl, setCurrentUrl] = useState<string | null>(null)

  useEffect(() => {
    const { pathname, search } = window.location
    let url: string | null = null
    if (pathname === '/' && search === '?s=recommended&t=all_time') {
      url = `${pathname}${search}`
    } else {
      url = pathname
    }
    setCurrentUrl(url)
    // get_information()
  }, [])

  // 跳转路由
  const go_to = (item: MenuItem) => {
    setCurrentUrl(item.url)
    if (item.url && item.url !== '-1' && item.url !== '-2') {
      history.push(item.url)
      if (props && props.from && props.from === 'Header') {
        props.hide()
      }
      return false
    }
    if (item.url === '-1' || item.url === '-2') {
      props.showTips()
      return false
    }
  }

  return (
    <ul className={styles.content_wrap_sidebar_head}>
      {MENU_ITEMS.map((item: any) => {
        return (
          <li
            key={item.id}
            className={currentUrl === item.url ? styles.selected : ''}
            onClick={() => go_to(item)}
          >
            <img src={item.icon} alt="" />
            {item.name}
          </li>
        )
      })}
    </ul>
  )
}

export default MenuItems
